import { render, staticRenderFns } from "./UserPaymentMethodForm.vue?vue&type=template&id=e1337522&"
import script from "./UserPaymentMethodForm.vue?vue&type=script&lang=js&"
export * from "./UserPaymentMethodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports